import { useStyles } from '@archipro-design/aria';
import React, { useEffect, useRef } from 'react';
import {
    AdvertSection,
    ContentSection,
} from '../detail-modules/DetailModules.style';
import { useTracker } from '@archipro-website/tracker';
import { useInViewport } from 'ahooks';

interface DetailShellSectionProps {
    children?: React.ReactNode;
    isAd?: boolean;
    percentContentViewed: number;
}

const DetailSection = ({
    children,
    isAd,
    percentContentViewed,
}: DetailShellSectionProps) => {
    const { css } = useStyles();
    const tracker = useTracker();
    const moduleRef = useRef<HTMLDivElement>(null);

    const [inView] = useInViewport(moduleRef);
    const eventFired = useRef(false);

    useEffect(() => {
        if (!inView || eventFired.current) return;
        tracker.log('PageModuleViewed', {
            url: new URL(window.location.href),
            targetTracker: ['archiproTracker', 'ga4Tracker'],
            data: {
                ExtraData: percentContentViewed,
            },
            ga4Data: { percentContentViewed },
        });
        eventFired.current = true;
    }, [inView, tracker, percentContentViewed, eventFired]);

    // The 'ad-section' class is crucial for the Resene colour picker to correctly identify and differentiate ad sections from content sections.
    return (
        <section
            className={
                isAd ? `${css(AdvertSection)} ad-section` : css(ContentSection)
            }
        >
            <div ref={moduleRef}>{children}</div>
        </section>
    );
};

export default DetailSection;
